import { render } from "./gerarMenu.vue?vue&type=template&id=34f031ac"
import script from "./gerarMenu.vue?vue&type=script&lang=js"
export * from "./gerarMenu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DealDesk\\Homologação\\Mult_Cliente\\front_mult_clint\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__